import { getTerms, termsSpeciesKeyFromSlug } from "@/lib/speciesTerms";
import { SERVICE_CATALOG } from "@/lib/serviceCatalog";

const SPECIES = [
  { slug: "canine", title: "Canine (Dogs)", keywords: ["dog", "dogs", "canine", "puppy", "puppies"] },
  { slug: "feline", title: "Feline (Cats)", keywords: ["cat", "cats", "feline", "kitten", "kittens"] },
  { slug: "equine", title: "Equine (Horses)", keywords: ["horse", "horses", "equine"] },
  { slug: "cattle", title: "Cattle (Cows)", keywords: ["cow", "cows", "cattle", "bull"] },
  { slug: "exotics", title: "Exotics", keywords: ["exotic", "exotics", "birds", "primates"] },
];

const QUICK_LINKS = [
  { title: "Recently Added", href: "/", keywords: ["recent", "recently", "new", "latest"] },
];

export function buildSearchIndex() {
  const pages = [];

  // Species browse
  for (const s of SPECIES) {
    pages.push({
      group: "Browse by Species",
      title: s.title,
      href: `/browse/${s.slug}`,
      keywords: [...s.keywords, "browse", "listings", "marketplace"],
    });
  }

  // Breeding
  for (const s of SPECIES) {
    const key = termsSpeciesKeyFromSlug(s.slug);
    const { male, female } = getTerms(key);

    pages.push({
      group: "Breeding",
      title: `Find a ${male} (${s.title})`,
      href: `/browse/${s.slug}/breeding/find?role=male`,
      keywords: [...s.keywords, "breeding", "stud", "sire", "male", male.toLowerCase(), "find"],
    });
    pages.push({
      group: "Breeding",
      title: `Register as a ${male} (${s.title})`,
      href: `/browse/${s.slug}/breeding/register?role=male`,
      keywords: [...s.keywords, "breeding", "stud", "sire", "male", male.toLowerCase(), "register", "list"],
    });
    pages.push({
      group: "Breeding",
      title: `Find a ${female} (${s.title})`,
      href: `/browse/${s.slug}/breeding/find?role=female`,
      keywords: [...s.keywords, "breeding", "dam", "female", female.toLowerCase(), "find"],
    });
    pages.push({
      group: "Breeding",
      title: `Register as a ${female} (${s.title})`,
      href: `/browse/${s.slug}/breeding/register?role=female`,
      keywords: [...s.keywords, "breeding", "dam", "female", female.toLowerCase(), "register", "list"],
    });
  }

  // Services
  for (const s of SPECIES) {
    for (const svc of SERVICE_CATALOG) {
      if (!svc.species.includes(s.slug)) continue;

      const baseKeywords = [
        ...s.keywords,
        "services",
        svc.type,
        svc.title.toLowerCase(),
      ];

      // aliases
      if (svc.type === "farrier") baseKeywords.push("horseshoe", "shoeing", "shoe smith");
      if (svc.type === "transport") baseKeywords.push("hauling", "trailer", "shipping", "delivery");
      if (svc.type === "veterinary") baseKeywords.push("vet", "clinic", "doctor");
      if (svc.type === "boarding") baseKeywords.push("kennel", "stable");

      pages.push({
        group: "Services",
        title: `Find a ${svc.title} (${s.title})`,
        href: `/browse/${s.slug}/services/find?type=${svc.type}`,
        keywords: [...baseKeywords, "find"],
      });
      pages.push({
        group: "Services",
        title: `Register as a ${svc.title} (${s.title})`,
        href: `/browse/${s.slug}/services/register?type=${svc.type}`,
        keywords: [...baseKeywords, "register", "list"],
      });
    }
  }

  for (const q of QUICK_LINKS) {
    pages.push({ group: "Quick Links", ...q });
  }

  return pages;
}

export function searchIndex(query, items) {
  const q = (query || "").trim().toLowerCase();
  if (!q) return [];

  const tokens = q.split(/\s+/).filter(Boolean);

  return items
    .map((item) => {
      const hay = [item.title, ...(item.keywords || [])].join(" ").toLowerCase();
      let score = 0;
      for (const t of tokens) {
        if (hay.includes(t)) score += 1;
      }
      // prefer title hits
      if (item.title.toLowerCase().includes(q)) score += 2;
      return { item, score };
    })
    .filter((r) => r.score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, 10)
    .map((r) => r.item);
}
